import request from '../utils/request';
/**
 * @description: 资讯详情
 * @param {*} data 
 */
export function informationDetail(data) {
  return request({
    url: '/api/weixin/InformationDetail',
    method: 'get',
    params: data,
  })
}